import { useNavigate } from 'react-router-dom'
import { Wallet } from 'lucide-react'
import { useCurrentSubscription } from '../hooks/use-current-subscription'

/**
 * Dismissible-by-nav banner that surfaces an expired subscription on every
 * authenticated screen. Renders inside the app shell, above `<main>`.
 *
 * Rendered only when the subscription is actually expired — silent otherwise.
 * Non-blocking for now; the full mutation feature-lock lands alongside the
 * first mutation hooks in Phase 5+ (create/edit/cancel bookings).
 */
export function ExpiredSubscriptionBanner() {
  const sub = useCurrentSubscription()
  const navigate = useNavigate()

  if (sub.isLoading || !sub.isExpired) return null

  return (
    <div className="expired-banner" role="alert">
      <Wallet size={14} />
      <div className="expired-banner-text">
        <strong>Tu suscripción ha expirado.</strong>{' '}
        Algunas funciones estarán en solo-lectura hasta que reanudes el plan.
      </div>
      <button
        type="button"
        className="btn primary sm"
        onClick={() => navigate('/settings')}
      >
        Reanudar
      </button>
    </div>
  )
}
